export default [
    {
        path: '/tTai',
        name: 'tTai',
        component: () => import('@/views/tTai/tTai'),
        meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false,
        }
    },
    {
        path: '/tTai_detail',
        name: 'tTai_detail',
        component: () => import('@/views/tTai/tTai_detail'),
        meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false,

        }
    },
    {
        path: '/t_detail',
        name: 't_detail',
        component: () => import('@/views/tTai/t_detail')
    },
]


// WEBPACK FOOTER //
// ./src/router/tTai.js